import { createGlobalStyle } from 'styled-components';


let heighScreen = window.innerHeight;
import styled from 'styled-components';
import vw_text from '@/assets/fonts/VWText.woff';
import vw_textLight from '@/assets/fonts/VWText-Light.woff';
import vw_head from '@/assets/fonts/VWHead.woff';
import vw_headLight from '@/assets/fonts/VWHead-Light.woff';
import vw_headBold from '@/assets/fonts/VWHead-Bold.woff';
import vw_textBold from '@/assets/fonts/VWText-Bold.woff';

export const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: 'vw-text';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_text}') format('woff');
  }
  @font-face {
    font-family: 'vw-text-light';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_textLight}') format('woff');
  }
  @font-face {
    font-family: 'vw-text-bold';
    font-style: normal;
    font-weight: bold;
    src: url('${vw_textBold}') format('woff');
  }

  @font-face {
    font-family: 'vw-head';
    font-style: normal;
    font-weight: normal;
    src: url('${vw_head}') format('woff');
  }
  @font-face {
    font-family: 'vw-head-light';
    font-style: normal;
    font-weight: 200;
    src: url('${vw_headLight}') format('woff');
  }
  @font-face {
    font-family: 'vw-head-bold';
    font-style: normal;
    font-weight: bold;
    src: url('${vw_headBold}') format('woff');
  }
 *{
  box-sizing: border-box;
  grid-template-rows: max-content;
 }
  
  html {
    line-height: 1.15;
    text-size-adjust: 100%;
}
  body {
    margin:0;
    padding:0;  
    background-color  : #fff;
}
p {margin:0 !important; padding:0!important; }

  input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,

input[type='password'] {
  input-security: none;
}
button{
  background: transparent;
    outline: none;
    border: none;
    cursor: pointer;    
}
button, [type="button"], [type="reset"], [type="submit"] {
    appearance: button;
}

button, select {
    text-transform: none;
}

button, input, select {
    overflow: visible;
    outline: none;
    outline: 0;
    border: none;
   
}

button, input, optgroup, select, textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0px;
}
  :root{ 
  --font-family-head: vw-head, Helvetica, Arial, sans-serif;
  --font-family-text: vw-text, Helvetica, Arial, sans-serif;
  --font-family-text-light: vw-text-light, Helvetica, Arial, sans-serif;
  --font-family-head-light: vw-head-light, Helvetica, Arial, sans-serif;
  --font-family-text-bold: vw-text-bold, Helvetica, Arial, sans-serif;
  --font-family-head-bold: vw-head-bold, Helvetica, Arial, sans-serif;
  font-family: var(--font-family-text);

  -webkit-font-smoothing: antialiased;
  --textappearances-copy100-fontsize: 12px;
  --textappearances-copy100-reducedfontsize: 12px;
  --textappearances-copy100-lineheight: 20px;
  --textappearances-copy100-letterspacing: 0.09px;
  --textappearances-copy150-fontsize: 14px;
  --textappearances-copy150-reducedfontsize: 12px;
  --textappearances-copy150-lineheight: 24px;
  --textappearances-copy150-letterspacing: 0.04px;
  --textappearances-copy200-fontsize: 16px;
  --textappearances-copy200-reducedfontsize: 12px;
  --textappearances-copy200-lineheight: 24px;
  --textappearances-copy200-letterspacing: 0px;
  --textappearances-copy250-fontsize: 20px;
  --textappearances-copy250-reducedfontsize: 12px;
  --textappearances-copy250-lineheight: 32px;
  --textappearances-copy250-letterspacing: -0.09px;
  --textappearances-copy300-fontsize: 24px;
  --textappearances-copy300-reducedfontsize: 12px;
  --textappearances-copy300-lineheight: 36px;
  --textappearances-copy300-letterspacing: -0.17px;
  --textappearances-headline200-fontsize: 16px;
  --textappearances-headline200-reducedfontsize: 12px;
  --textappearances-headline200-lineheight: 20px;
  --textappearances-headline200-letterspacing: 0px;
  --textappearances-headline250-fontsize: 20px;
  --textappearances-headline250-reducedfontsize: 12px;
  --textappearances-headline250-lineheight: 24px;
  --textappearances-headline250-letterspacing: -0.09px;
  --textappearances-headline300-fontsize: 24px;
  --textappearances-headline300-reducedfontsize: 12px;
  --textappearances-headline300-lineheight: 28px;
  --textappearances-headline300-letterspacing: -0.17px;
  --textappearances-headline350-fontsize: 28px;
  --textappearances-headline350-reducedfontsize: 16px;
  --textappearances-headline350-lineheight: 32px;
  --textappearances-headline350-letterspacing: -0.26px;
  --textappearances-headline400-fontsize: 32px;
  --textappearances-headline400-reducedfontsize: 16px;
  --textappearances-headline400-lineheight: 36px;
  --textappearances-headline400-letterspacing: -0.35px;
  --textappearances-headline450-fontsize: 44px;
  --textappearances-headline450-reducedfontsize: 24px;
  --textappearances-headline450-lineheight: 52px;
  --textappearances-headline450-letterspacing: -0.61px;
  --textappearances-headline500-fontsize: 56px;
  --textappearances-headline500-reducedfontsize: 28px;
  --textappearances-headline500-lineheight: 64px;
  --textappearances-headline500-letterspacing: -0.88px;
  --textappearances-headline550-fontsize: 84px;
  --textappearances-headline550-reducedfontsize: 44px;
  --textappearances-headline550-lineheight: 96px;
  --textappearances-headline550-letterspacing: -1.49px;
  --textappearances-headline600-fontsize: 100px;
  --textappearances-headline600-reducedfontsize: 52px;
  --textappearances-headline600-lineheight: 112px;
  --textappearances-headline600-letterspacing: -1.84px;
  --textappearances-label100-fontsize: 12px;
  --textappearances-label100-reducedfontsize: 12px;
  --textappearances-label100-lineheight: 16px;
  --textappearances-label100-letterspacing: 0.09px;
  --textappearances-label150-fontsize: 14px;
  --textappearances-label150-reducedfontsize: 12px;
  --textappearances-label150-lineheight: 16px;
  --textappearances-label150-letterspacing: 0.04px;
  --textappearances-label200-fontsize: 16px;
  --textappearances-label200-reducedfontsize: 12px;
  --textappearances-label200-lineheight: 20px;
  --textappearances-label200-letterspacing: 0px;
  --textappearances-label250-fontsize: 20px;
  --textappearances-label250-reducedfontsize: 12px;
  --textappearances-label250-lineheight: 24px;
  --textappearances-label250-letterspacing: -0.09px;
  --textappearances-label300-fontsize: 24px;
  --textappearances-label300-reducedfontsize: 12px;
  --textappearances-label300-lineheight: 28px;
  --textappearances-label300-letterspacing: -0.17px;
  --size-grid001: 4.16vw;
  --size-grid002: 8.33vw;
  --size-grid003: 12.5vw;
  --size-grid004: 16.66vw;
  --size-grid005: 20.83vw;
  --size-grid006: 25vw;
  --size-grid007: 29.16vw;
  --size-grid008: 33.33vw;
  --size-grid009: 37.5vw;
  --size-grid010: 41.66vw;
  --size-grid011: 45.83vw;
  --size-grid012: 50vw;
  --size-grid013: 54.16vw;
  --size-grid014: 58.33vw;
  --size-grid015: 62.5vw;
  --size-grid016: 66.66vw;
  --size-grid017: 70.83vw;
  --size-grid018: 75vw;
  --size-grid019: 79.16vw;
  --size-grid020: 83.33vw;
  --size-grid021: 87.5vw;
  --size-grid022: 91.66vw;
  --size-grid023: 95.83vw;
  --size-grid024: 100vw;
  --size-dynamic0020: 4px;
  --size-dynamic0040: 12px;
  --size-dynamic0050: 12px;
  --size-dynamic0100: 20px;
  --size-dynamic0120: 24px;
  --size-dynamic0130: 24px;
  --size-dynamic0140: 28px;
  --size-dynamic0150: 28px;
  --size-dynamic0200: 32px;
  --size-dynamic0250: 44px;
  --size-dynamic0270: 56px;
  --size-dynamic0300: 72px;
  --size-dynamic0350: 100px;
  --size-dynamic0450: 156px;
  }
@media (min-width: 560px) {
   :root{ --textappearances-headline350-fontsize: 32px;
    --textappearances-headline350-reducedfontsize: 16px;
    --textappearances-headline350-lineheight: 36px;
    --textappearances-headline350-letterspacing: -0.35px;
    --textappearances-headline400-fontsize: 48px;
    --textappearances-headline400-reducedfontsize: 24px;
    --textappearances-headline400-lineheight: 56px;
    --textappearances-headline400-letterspacing: -0.7px;
    --textappearances-headline450-fontsize: 60px;
    --textappearances-headline450-reducedfontsize: 32px;
    --textappearances-headline450-lineheight: 68px;
    --textappearances-headline450-letterspacing: -0.96px;
    --textappearances-headline500-fontsize: 72px;
    --textappearances-headline500-reducedfontsize: 36px;
    --textappearances-headline500-lineheight: 80px;
    --textappearances-headline500-letterspacing: -1.22px;
    --textappearances-headline550-fontsize: 96px;
    --textappearances-headline550-reducedfontsize: 48px;
    --textappearances-headline550-lineheight: 108px;
    --textappearances-headline550-letterspacing: -1.75px;
    --textappearances-headline600-fontsize: 116px;
    --textappearances-headline600-reducedfontsize: 60px;
    --textappearances-headline600-lineheight: 128px;
    --textappearances-headline600-letterspacing: -2.19px;
    --size-dynamic0020: 4px;
    --size-dynamic0040: 20px;
    --size-dynamic0050: 20px;
    --size-dynamic0100: 24px;
    --size-dynamic0120: 20px;
    --size-dynamic0130: 40px;
    --size-dynamic0140: 32px;
    --size-dynamic0150: 52px;
    --size-dynamic0200: 56px;
    --size-dynamic0250: 68px;
    --size-dynamic0270: 80px;
    --size-dynamic0300: 96px;
    --size-dynamic0350: 132px;
    --size-dynamic0450: 172px;
   }
  }

`;



